import React, { useState } from 'react';
import Button from './Button';
import InfoCard from './InfoCard';

const WorkshopForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = Object.fromEntries(new FormData(e.target).entries());

    try {
      await fetch('https://script.google.com/macros/s/AKfycbx4F7lIgfGh1UbmgJ-jk_XRJRk8_R1ZksspphxSWF5jJ3bJwuHnHybuPzMbHP7wNKdAPg/exec', {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, category: 'Workshop Inquiry' }),
      });
      setSubmitted(true);
      e.target.reset();
    } catch (error) {
      console.error('Error submitting form', error);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return <p style={{ color: '#4ade80', textAlign: 'center' }}>Your message has been received. We'll get back to you soon!</p>;
  }

  return (
    <InfoCard
      title="Get Started Today"
      subtitle="We'll design a workshop tailored to your goals"
      style={{
        background: 'rgba(99, 102, 241, 0.1)',
        border: '1px solid rgba(99, 102, 241, 0.25)',
        padding: '2rem',
        borderRadius: '1rem',
        maxWidth: '800px',
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          maxWidth: '600px',
          margin: '0 auto',
        }}
      >
        <input name="name" required placeholder="Name*" style={inputStyle} />
        <input name="email" required type="email" placeholder="Email*" style={inputStyle} />
        <input name="company" required placeholder="Company Name*" style={inputStyle} />
        <textarea name="message" required placeholder="Preferred focus areas, audience, location, etc.*" rows={3} style={{ ...inputStyle, resize: 'vertical', minHeight: '50px' }} />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {loading ? (
            <div
              className="loader"
              style={{
                width: '24px',
                height: '24px',
                border: '3px solid #999',
                borderTop: '3px solid #fff',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite',
              }}
            />
          ) : (
            <Button label="Submit" type="submit" />
          )}
        </div>
      </form>
    </InfoCard>
  );
};

const inputStyle = {
  padding: '0.75rem',
  borderRadius: '0.5rem',
  border: '1px solid #333',
  fontSize: '1rem',
  backgroundColor: '#1a1a2e',
  color: '#fff',
  width: '80%',
  margin: '0 auto',
};

export default WorkshopForm;
